module.exports = __webpack_public_path__ + "static/media/banner-photo1024.69e99028.jpg";